<template>
  <table class="table table-striped table-condensed">
    <thead>
    <tr>
      <th class="col-xs-6">
        <a href="#" @click.prevent="sort('portal_name')">
          Portal <i class="fa fa-sort"></i>
        </a>
      </th>

      <th class="col-xs-4">
        <a href="#" @click.prevent="sort('index')">
          Index <i class="fa fa-sort"></i>
        </a>
      </th>

      <th class="col-xs-4">
        <a href="#" @click.prevent="sort('revenue')">
          Revenue <i class="fa fa-sort"></i>
        </a>
      </th>

      <th class="col-xs-4">
        <a href="#" @click.prevent="sort(targetMetric)">
          Target <i class="fa fa-sort"></i>
        </a>
      </th>

      <th class="col-xs-6">
        <a href="#" @click.prevent="sort('difference')">
          Difference <i class="fa fa-sort"></i>
        </a>
      </th>
    </tr>
    </thead>

    <tbody>
    <tr v-for="row in sortedRows">
      <td>
        <span :style="{'background-color': row.portal_color}">
          &nbsp;&nbsp;&nbsp;&nbsp;
        </span>

        &nbsp;

        <router-link :to="'/portals/' + row.portal_id + '/dashboard/' + year">
          {{ row.portal_name }}
        </router-link>
      </td>

      <td>
        <index-number :value="row.index"></index-number>
      </td>

      <td>
        {{ row.ad_value_after_costs | price }}
      </td>

      <td>
        {{ row[targetMetric] | price }}
      </td>

      <td>
        <difference-number :value="row.difference"></difference-number>
      </td>
    </tr>
    </tbody>

    <tfoot>
    <tr>
      <td>
        Total
      </td>

      <td>
        <index-number :value="totalIndex"></index-number>
      </td>

      <td>
        {{ totalRevenue | price }}
      </td>

      <td>
        {{ totalTarget | price }}
      </td>

      <td>
        <difference-number :value="totalDifference"></difference-number>
      </td>
    </tr>
    </tfoot>
  </table>
</template>

<script>
import DifferenceNumber from '@/components/Numbers/DifferenceNumber'
import IndexNumber from '@/components/Numbers/IndexNumber'

export default {
  components: {DifferenceNumber, IndexNumber},

  props: ['targetMetric', 'year', 'rows'],

  data() {
    return {
      sortBy: 'portal_name',
      sortDirection: -1,
    }
  },

  computed: {
    sortedRows() {
      return this.rows.sort((a, b) => {
        return a[this.sortBy] > b[this.sortBy] ? -this.sortDirection : this.sortDirection
      })
    },

    totalIndex() {
      if (!this.totalTarget) {
        return null
      }

      return this.totalRevenue / this.totalTarget * 100
    },

    totalRevenue() {
      return this.rows.reduce((total, row) => {
        return total + row.ad_value_after_costs
      }, 0)
    },

    totalTarget() {
      return this.rows.reduce((total, row) => {
        return total + row[this.targetMetric]
      }, 0)
    },

    totalDifference() {
      return this.rows.reduce((total, row) => {
        return total + row.difference
      }, 0)
    }
  },

  methods: {
    sort(key) {
      if (this.sortBy === key) {
        return this.sortDirection = -this.sortDirection
      }

      this.sortDirection = key === 'portal_name' ? -1 : 1

      this.sortBy = key
    }
  }
}
</script>
